import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime,
    dataURLtoFile,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoConfirmDialog, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoLabel,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer, RaikoSimpleInputOutlined, RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {VideoService} from "../../serverService/videos/VideoService";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import {stringIsEmpty} from "../../util/VariableChecker";
import RaikoAparatVideoSelector from "../../raikoComponents/raikoCustomBlogEditor/aparatVideo/RaikoAparatVideoSelector";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";
import RaikoTextEditor from "../../raikoComponents/raikoTextEditor/RaikoTextEditor";
import AdvanceRichEditor from "../../raikoComponents/raikoEditor/raikoRichEditor/AdvanceRichEditor";

export default function VideoDetail() {

    const {state} = useLocation()
    const [clipTitle, setClipTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineVideosDetail.name)
    const navigate = useNavigate()

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new VideoService()


    const [postedAt, setPostedAt] = useState("")
    const [postedBy, setPostedBy] = useState("")
    const [openConFirmDialog, setOpenConfirmDialog] = useState(false);
    const openDeleteDialog = () => setOpenConfirmDialog(true)
    const closeDeleteDialog = () => setOpenConfirmDialog(false)

    const [tabValue, setTabValue] = useState(tabTypes.Detail.id)

    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }

    const {id: clipId} = useParams()

    const [buttonLoading, setButtonLoading] = useState(false)

    const [photoFile, setPhotoFile] = useState(null)
    const [photoUrl, setPhotoUrl] = useState("");
    const [photoId, setPhotoId] = useState(-1);
    const [thumbnailLoadingState, setThumbnailLoadingState] = useState(false);

    const [title, setTitle] = useState("");
    const [writerName, setWriterName] = useState("");
    const [aparatLink, setAparatLink] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState("")


    useEffect(() => {
        if (typeof service !== 'undefined' && typeof clipId !== 'undefined') {
            getDetailFromServer()
        }
    }, [clipId]);

    function getDetailFromServer() {
        loading.show()
        service.getVideoDetail(
            clipId
        ).then(response => {
            setAparatLink(response.aparatScript)
            setWriterName(response.authorInformation)
            setDescription(response.description)
            setShortDescription(response.shortDescription)
            setTitle(response.title)
            setPhotoUrl(response.thumbnailInformation.url)
            setPhotoId(response.thumbnailInformation.id)

            setPostedAt(convertUniversalDateTimeToPersianDateTime(response.postedAt))
            setPostedBy(response.postedBy)
        }).catch(reason => {
            showWarningMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    const handleSelectImage = (imgSrc, fileName) => {
        const imageFile = dataURLtoFile(imgSrc, fileName)
        setPhotoUrl(imgSrc)
        setPhotoFile(imageFile)
    }

    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا عنوان کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نویسنده کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(aparatLink))
            message = "لطفا لینک آپارات را به درستی وارد نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه کلیپ را به درستی وارد نمایید."
        else if (stringIsEmpty(description) || description === "<p><br></p>")
            message = "لطفا توضیحات کلیپ را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state

    }

    function deleteNotification() {
        loading.show()
        service.deleteVideo(clipId, title, writerName, shortDescription, description, aparatLink, photoId, false).then(
            response => {
                showSuccessMessage("کلیپ با موفقیت حذف شد.")
                closeDeleteDialog()
                navigate(
                    RouteHelper.MagazineVideos.globalUrl,
                    {replace: true}
                )
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function updateVideoClip() {
        if (checkFields()) {
            setButtonLoading(true)
            service.updateClipInfo(
                clipId,
                title,
                writerName,
                aparatLink,
                photoFile,
                photoId,
                shortDescription,
                description,
                true
            ).then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setButtonLoading(false)
            })
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineVideoDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openConFirmDialog}
                doAction={deleteNotification}
                pageTitle={"حذف کلیپ"}
                warningTitle={"آیا از حذف کلیپ اطمینان دارید؟"}
            />
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={
                                [raikoBreadCrumbItemGenerator(
                                    RouteHelper.MagazineVideos.name,
                                    RouteHelper.MagazineVideos.globalUrl
                                ), raikoBreadCrumbItemGenerator(
                                    clipTitle,
                                    ""
                                )
                                ]
                            }
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>

                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={tabValue}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Detail.title}
                                     value={tabTypes.Detail.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={tabTypes.Detail.id}>
                            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"کلیپ"}
                                        hasActionButton={true}
                                        actionButtonTitle={"بروزرسانی"}
                                        actionButtonOnclick={updateVideoClip}
                                        actionButtonLoadingState={buttonLoading}
                                        hasSecondaryButton={true}
                                        secondaryButtonTitle={"حذف"}
                                        secondaryButtonOnClick={openDeleteDialog}
                                    >
                                        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;
                                          max-width: 100vw;`}>
                                            <RaikoGridTwoColumn>
                                                <RaikoSimpleInputOutlined
                                                    labelText={"عنوان"}
                                                    value={title}
                                                    setValue={setTitle}
                                                />
                                                <RaikoSimpleInputOutlined
                                                    labelText={"نویسنده"}
                                                    value={writerName}
                                                    setValue={setWriterName}
                                                />
                                            </RaikoGridTwoColumn>
                                            <RaikoAparatVideoSelector value={aparatLink} setVideo={setAparatLink}/>
                                            <RaikoSectionContainer
                                                title={"تصویر شاخص"}
                                            >
                                                <UploadThumbnail
                                                    avatarFile={photoUrl}
                                                    updateAvatar={handleSelectImage}
                                                    loading={thumbnailLoadingState}
                                                />
                                            </RaikoSectionContainer>
                                            <RaikoSimpleMultiLineInputOutlined
                                                labelText={"توضیحات کوتاه"}
                                                value={shortDescription}
                                                setValue={setShortDescription}
                                            />
                                            <RaikoLabel text={"توضیحات"}/>

                                            <AdvanceRichEditor
                                                text={description}
                                                setText={setDescription}
                                            />
                                        </RaikoGridOneColumn>
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>
                                <RaikoCreatorInfo createdBy={postedBy} createdAt={postedAt}/>
                            </RaikoGridOneColumn>
                        </TabPanel>
                    </TabContext>


                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}

const tabTypes = {
    Detail: {
        id: "details",
        title: "جزئیات کلیپ"
    },
}
